import Logger from '../Logger';

const create = (callback) => {
  window.addEventListener('message', ((event) => {
    let data;
    try {
      data = JSON.parse(event.data);
    } catch (error) {
      if (/verbose/.test(window.location.search)) {
        Logger.error(error);
      }
    }
    if (data !== undefined) callback(data);
  }), false);
};

export default {
  create,
};
